import React, { useState } from 'react';
import axios from 'axios';
import { Mail, ArrowRight, CheckCircle2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || status === 'loading') return;
    setStatus('loading');
    try {
      const res = await axios.post(`${API}/api/newsletter/subscribe`, { email, source: 'blog' });
      setStatus('success');
      setMessage(res.data.message);
      setEmail('');
    } catch (err) {
      setStatus('error');
      setMessage(err.response?.status === 422 ? "Adresse e-mail invalide — vérifiez votre saisie." : "Une erreur est survenue, merci de réessayer.");
    }
  };

  return (
    <section data-testid="newsletter-section" style={{ background: 'var(--bg-section)', padding: '4.5rem 0' }}>
      <div className="container" style={{ maxWidth: '760px' }}>
        <div style={{
          background: 'white',
          borderRadius: '1.5rem',
          border: '1px solid var(--border-light)',
          boxShadow: '0 10px 40px rgba(28, 35, 33, 0.06)',
          padding: '3rem 2.5rem',
          textAlign: 'center'
        }}>
          <span style={{
            color: 'var(--accent-warm)',
            letterSpacing: '0.15em',
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '0.8rem',
            display: 'inline-block',
            marginBottom: '1rem'
          }}>
            Newsletter
          </span>
          <h2 className="heading-2" style={{ marginBottom: '0.75rem' }}>
            Recevez nos conseils nutrition & hormones
          </h2>
          <p className="body-medium" style={{ color: 'var(--text-muted)', maxWidth: '520px', margin: '0 auto 2rem', lineHeight: 1.7 }}>
            Nouveaux articles, conseils pratiques et actualités du centre, directement dans votre boîte e-mail. Sans spam, désinscription à tout moment.
          </p>

          {status === 'success' ? (
            <div
              data-testid="newsletter-success"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.6rem',
                background: 'var(--accent-primary-light)',
                color: 'var(--accent-primary)',
                padding: '0.9rem 1.5rem',
                borderRadius: '999px',
                fontWeight: 600
              }}
            >
              <CheckCircle2 size={20} />
              {message}
            </div>
          ) : (
            <form onSubmit={submit} data-testid="newsletter-form" style={{
              display: 'flex',
              gap: '0.75rem',
              maxWidth: '480px',
              margin: '0 auto',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}>
              <div style={{ position: 'relative', flex: '1 1 260px' }}>
                <Mail size={18} style={{ position: 'absolute', left: '1.1rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); if (status === 'error') setStatus('idle'); }}
                  placeholder="Votre adresse e-mail"
                  data-testid="newsletter-email-input"
                  style={{
                    width: '100%',
                    padding: '0.95rem 1.25rem 0.95rem 2.9rem',
                    borderRadius: '999px',
                    border: '1px solid var(--border-input)',
                    fontSize: '0.95rem',
                    outline: 'none',
                    background: 'var(--bg-page)',
                    color: 'var(--text-primary)',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              <button
                type="submit"
                className="btn-primary"
                data-testid="newsletter-submit-btn"
                disabled={status === 'loading'}
                style={{ opacity: status === 'loading' ? 0.7 : 1 }}
              >
                {status === 'loading' ? 'Inscription…' : "S'inscrire"}
                <ArrowRight size={18} />
              </button>
            </form>
          )}

          {status === 'error' && (
            <p data-testid="newsletter-error" style={{ color: '#B3423A', fontSize: '0.9rem', marginTop: '1rem', marginBottom: 0 }}>
              {message}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default NewsletterSignup;
